module.exports = __webpack_public_path__ + "static/media/sss-auto-icon-noneOption.c0a51e9a.svg";